import { take, fork, cancel } from "redux-saga/effects";
import { CONNECT_SSE, DISCONNECT_SSE } from "../connectSse/action";
import { connectSseSaga } from "../connectSse/connectSseSaga";

export function* watchSseSaga() {
  let sseTask;

  while (true) {
    const action = yield take([CONNECT_SSE, DISCONNECT_SSE]);

    if (action.type === CONNECT_SSE) {
      if (sseTask) yield cancel(sseTask);
      sseTask = yield fork(connectSseSaga);
    }

    if (action.type === DISCONNECT_SSE) {
      if (sseTask) {
        yield cancel(sseTask);
        sseTask = null;
        console.log("SSE connection cancelled");
      }
    }
  }
}